// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shareLinkStyles } from "@awc/Overrides/Widgets/ProductDetails/ProductDetailsShareLink";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { iconLinkCommonStyles, mergeWithCss } from "@awc/XDL/Utilities";
import File from "@insite/mobius/Icons/File";
import Mail from "@insite/mobius/Icons/Mail";
import Printer from "@insite/mobius/Icons/Printer";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { css } from "styled-components";

const linkStyles: LinkPresentationProps = {
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
};

shareLinkStyles.wrapper = {
    css: css`
        display: flex;
        align-content: center;
        gap: 24px;
        flex-wrap: wrap;
    `,
};
shareLinkStyles.printLink = {
    ...mergeWithCss(iconLinkCommonStyles(Printer), linkStyles),
};

shareLinkStyles.copyLink = {
    ...mergeWithCss(iconLinkCommonStyles(File), linkStyles),
};
shareLinkStyles.link = {
    link: {
        ...mergeWithCss(iconLinkCommonStyles(Mail), linkStyles),
    },
    buttonsWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: end;
        `,
    },
};
